var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9027 3.7876C6.97288 3.7876 3.78711 6.97337 3.78711 10.9032C3.78711 14.8331 6.97288 18.0188 10.9027 18.0188C14.8326 18.0188 18.0184 14.8331 18.0184 10.9032C18.0184 6.97337 14.8326 3.7876 10.9027 3.7876ZM2.66211 10.9032C2.66211 6.35205 6.35156 2.6626 10.9027 2.6626C15.4539 2.6626 19.1434 6.35205 19.1434 10.9032C19.1434 15.4544 15.4539 19.1438 10.9027 19.1438C6.35156 19.1438 2.66211 15.4544 2.66211 10.9032Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9343 15.935C16.154 15.7153 16.5101 15.7153 16.7298 15.935L21.1722 20.3774C21.3918 20.5971 21.3918 20.9532 21.1722 21.1729C20.9525 21.3926 20.5964 21.3926 20.3767 21.1729L15.9343 16.7305C15.7146 16.5108 15.7146 16.1547 15.9343 15.935Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.66c39126871d6c2fdc2df0969ef6c547.svg";
export { ForwardRef as ReactComponent };